
import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, MapPin, Phone, Clock, ArrowRight } from 'lucide-react';

export const Footer: React.FC = () => (
  <footer className="bg-concrete-dark text-slate-400 border-t-4 border-brand-red relative">
    <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/graphy.png')] opacity-5 pointer-events-none"></div>
    <div className="container mx-auto px-6 py-16 relative z-10">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="mb-8">
            <h2 className="font-display font-bold text-2xl text-white uppercase leading-tight">
               Béton Mobile <br/><span className="text-brand-red">des Cantons inc.</span>
            </h2>
          </div>
          <p className="text-sm leading-relaxed mb-6 font-mono text-slate-500">
            RBQ: 8350-1361-26
            <br/>EST. 1983
          </p>
          <div className="flex gap-2 mb-6">
             <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-slate-800 border border-slate-700 hover:bg-brand-red hover:text-white hover:border-brand-red transition-all" aria-label="Facebook"><Facebook size={18} /></a>
             <a href="mailto:info@betonmobiledescantons.com" className="w-10 h-10 flex items-center justify-center bg-slate-800 border border-slate-700 hover:bg-brand-red hover:text-white hover:border-brand-red transition-all" aria-label="Email"><Mail size={18} /></a>
          </div>
          <p className="text-xs text-slate-600">
            Expert en béton fabriqué sur chantier et planchers radiants de haute qualité.
          </p>
        </div>
        <div>
          <h3 className="text-white font-display font-bold uppercase tracking-widest mb-6 text-sm border-b border-slate-800 pb-2 w-fit">Navigation</h3>
          <ul className="space-y-3 text-sm font-medium">
            <li><Link to="/" className="hover:text-brand-red transition-colors flex items-center gap-2"><ArrowRight size={12} className="text-slate-600"/> Accueil</Link></li>
            <li><Link to="/realisations" className="hover:text-brand-red transition-colors flex items-center gap-2"><ArrowRight size={12} className="text-slate-600"/> Nos Réalisations</Link></li>
            <li><Link to="/services" className="hover:text-brand-red transition-colors flex items-center gap-2"><ArrowRight size={12} className="text-slate-600"/> Tous les Services</Link></li>
            <li><Link to="/contact" className="hover:text-brand-red transition-colors flex items-center gap-2"><ArrowRight size={12} className="text-slate-600"/> Contact / Soumission</Link></li>
            <li><Link to="/plan-du-site" className="hover:text-brand-red transition-colors flex items-center gap-2"><ArrowRight size={12} className="text-slate-600"/> Plan du site</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-display font-bold uppercase tracking-widest mb-6 text-sm border-b border-slate-800 pb-2 w-fit">Spécialités</h3>
          <ul className="space-y-3 text-sm font-medium">
            <li><Link to="/beton" className="hover:text-brand-red transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-brand-red"></div> Béton Mobile</Link></li>
            <li><Link to="/plancher-radiant" className="hover:text-brand-red transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-brand-red"></div> Plancher Radiant</Link></li>
            <li><Link to="/coffrage-et-fondation" className="hover:text-brand-red transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-brand-red"></div> Location Coffrage</Link></li>
            <li><Link to="/services" className="hover:text-brand-red transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-brand-red"></div> Produits & Outils</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-display font-bold uppercase tracking-widest mb-6 text-sm border-b border-slate-800 pb-2 w-fit">Info Contact</h3>
          <ul className="space-y-4 text-sm font-mono mb-8">
            <li className="flex items-start gap-3">
              <MapPin className="text-brand-red shrink-0" size={16} />
              <span>875, rue Dufferin,<br/>Granby (Québec) J1H 0T7</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="text-brand-red shrink-0" size={16} />
              <span className="text-white font-bold">450 372-2565</span>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="text-brand-red shrink-0" size={16} />
              <span>Lun - Ven: 7h00 - 17h00</span>
            </li>
          </ul>
          <h4 className="text-xs text-slate-500 uppercase font-bold mb-2">Zones desservies</h4>
           <div className="flex flex-wrap gap-2 font-mono text-[10px]">
             {["Granby", "Haute-Yamaska", "Cantons-de-l'Est", "Estrie", "Montérégie"].map((zone, i) => (
               <span key={i} className="px-2 py-1 bg-slate-800 text-slate-300 border border-slate-700 hover:border-brand-red transition-colors">{zone}</span>
             ))}
           </div>
        </div>
      </div>
      <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-600 font-mono">
        <p>© 2024 Béton Mobile des Cantons inc. Droits réservés.</p>
        <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/plan-du-site" className="hover:text-brand-red transition-colors">Plan du site</Link>
            <a href="https://techwebsiteglobal.ca" target="_blank" rel="noopener noreferrer" className="hover:text-brand-red transition-colors">Conception : TechWebsiteGlobal.ca</a>
        </div>
      </div>
    </div>
  </footer>
);
